import { useState, Fragment, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import MainPageMenu from "./MainPageMenu";
import { toast } from "react-toastify";
import { checkResponseData, customToastify, checkErrorMessage } from "../utils/utils";
import OneBoxDetails from "./OneBoxDetails/OneBoxDetails";
import Box from "@mui/material/Box";
import CreateNewBox from "./Boxs/CreateNewBox";
import { Link } from "react-router-dom";
import { Typography, Button, Divider } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AlertDeleteBox from "./AlertDeleteBox";
import { deleteBoxApi } from "../../services/leitnerApi";
import LoginMenu from "./LoginMenu"

export default function MainPage(props) {
  const {
    controlThemeMode,
    boxesList,
    handleEditBoxlist,
    handleStartStudy,
    handleStudyCards,
    setBoxDetails,
    oneBox,
    userTypes,
    handleUserTypes,
    CheckUserSignIn
  } = props;
  const [openNewBox, setOpenNewBox] = useState(false);
  const [editBox, setEditBox] = useState(false);
  const [openAlert, setOpenAlert] = useState({
    open: false,
    title: "",
    text: "",
    info: false,
  });

  const handleEditBox = (state) => {
    setEditBox(state);
  };

  const handleDeleteBox = async (state) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      if (state == "confirmDelete") {
        let data = { boxId: oneBox["boxId"] };
        // console.log("datadata", data);
        const deletedBox = await deleteBoxApi({ boxId: oneBox["boxId"] })
        const resData = checkResponseData(deletedBox);
        if (deletedBox["data"] && deletedBox["data"]["success"]) {
          setOpenAlert({
            open: true,
            title: "تعداد کارتهای حذف شده",
            text: `تعداد کارت حذف شده: ${deletedBox["data"]["data"]["data"][0]["countCard"]["deletedCount"]}`,
            info: true,
          });
          const newBoxList = [...boxesList];
          let idx;
          for (let index in newBoxList) {
            if (newBoxList[index]["_id"] == oneBox["boxId"]) {
              idx = index;
            }
          }
          if (idx > 0) newBoxList.splice(idx, 1);

          handleEditBoxlist(newBoxList);
          setBoxDetails(false, null);
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          setOpenAlert({
            open: true,
            title: "خطا",
            text: `مشکلی در حذف لایتنر وجود دارد`,
            info: true,
          });
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });

        }
      }
      if (state == "cancelDelete")
        setOpenAlert({ open: false, title: "", text: "", info: false });
      if (state == "openAlertDelte")
        setOpenAlert({
          open: true,
          title: "آیا مطمین هستید",
          text: " آیا از حذف این لایتنر مطمین هستید؟",
          info: false,
        });
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });

    }

  };
  const hsndleOpenNewBox = () => {
    setOpenNewBox(!openNewBox);
  };

  return (
    <>
      <MainPageMenu
        controlThemeMode={controlThemeMode}
        oneBox={oneBox}
        handleEditBox={handleEditBox}
        handleDeleteBox={handleDeleteBox}
        userTypes={userTypes}
      />
      <CssBaseline />
      {!userTypes.includes("user") ?
        <LoginMenu handleUserTypes={handleUserTypes} CheckUserSignIn={CheckUserSignIn} /> : <>
          {!oneBox["state"] ? (
            <>
              <Box sx={{ textAlign: "end", mt: 1 }}>
                <Link to="/" style={{ textDecoration: "none" }}>
                  <Button
                    sx={{ p: 0.1, mx: 1, mt: 0 }}
                    variant="contained"
                    color="info"
                    size="small"
                    endIcon={<KeyboardBackspaceIcon />}
                  >
                    بازگشت
                  </Button>
                </Link>
              </Box>

              <List dense={true} component="nav">
                {boxesList.length == 0 ? (
                  <Typography
                    sx={{ textAlign: "center", mt: 1, fontWeight: "bold" }}
                  >
                    لایتنری تا کنون نساخته اید
                  </Typography>
                ) : (
                  boxesList.map(({ _id, name, secondary }, index) => (
                    <Fragment key={index + _id}>
                      <ListItemButton
                        onClick={() => {
                          // console.log(_id);
                          setBoxDetails(true, _id);
                        }}
                      >
                        <ListItemIcon>
                          <KeyboardDoubleArrowLeftIcon />
                        </ListItemIcon>
                        <ListItemText primary={name} />
                      </ListItemButton>
                      <Divider />
                    </Fragment>
                  ))
                )}
              </List>
              <Box sx={{ textAlign: "center", mt: 1 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={hsndleOpenNewBox}
                >
                  ساخت میزکار جدید
                </Button>
              </Box>
            </>
          ) : (
            <OneBoxDetails
              handleEditBox={handleEditBox}
              editBox={editBox}
              setBoxDetails={setBoxDetails}
              handleEditBoxlist={handleEditBoxlist}
              boxesList={boxesList}
              oneBox={oneBox}
              handleStartStudy={handleStartStudy}
              handleStudyCards={handleStudyCards}
            />
          )}
          <CreateNewBox
            openNewBox={openNewBox}
            hsndleOpenNewBox={hsndleOpenNewBox}
            handleEditBoxlist={handleEditBoxlist}
            boxesList={boxesList}
          />
          <AlertDeleteBox openAlert={openAlert} handleDeleteBox={handleDeleteBox} />
        </>}

    </>
  );
}
